import { render } from "./ModalInformativoInvestidor.vue?vue&type=template&id=6d84a14a&scoped=true"
import script from "./ModalInformativoInvestidor.vue?vue&type=script&lang=js"
export * from "./ModalInformativoInvestidor.vue?vue&type=script&lang=js"

import "./ModalInformativoInvestidor.vue?vue&type=style&index=0&id=6d84a14a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d84a14a"]])

export default __exports__